import styled from 'styled-components';

const MyDiv = styled.div`
  .bg-border {
    background: rgba(0, 0, 0, 0.1);
    height: 100%;
    width: 1px;
  }
  .main{
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.35));
  }
  .bg-filter {
    background: rgba(0, 0, 0, 0.1);
    height: 1px;
    width: 100%;
  }
  .checkbox-container {
    max-height: 250px;
    overflow-y: auto;
    padding-right: 8px;
  }
  .text_bold{
    font-family: "Poppins", sans-serif!important;
    font-size:12px;
    font-weight:600px;

  }
  .text_regular{
    font-family: "Poppins", sans-serif!important;
    font-size:12px;
    font-weight:500px;
  }
`;


export default MyDiv;